import React from 'react';
import PropTypes from 'prop-types';
import { SFEntityID } from 'utils/types';
import css from './RadioGroup.css';
import RadioOption from 'common/RadioOption';
import RadioOptionLabel from './RadioOptionLabel';

export default class RadioGroup extends React.Component {

  render() {
    if ( !this.props.options ) return null;
    return (
      <div className={css['group-container']} data-role="optionsContainer">
        {this.props.options.map((option, i) => (
          <RadioOption
            key={i}
            id={`${this.props.name}-${i}`}
            value={option.id}
            radioName={this.props.name}
            onChange={() => this.props.onSelectOption(option.id)}
            label={<RadioOptionLabel text={option.name} htmlFor={`${this.props.name}-${i}`} />} 
            isChecked={parseInt(option.id) === parseInt(this.props.value)}
          />
        ))}
      </div>
    );
  }
}

RadioGroup.propTypes = {
  value: SFEntityID,
  name: PropTypes.string.isRequired,
  onSelectOption: PropTypes.func.isRequired,
  options: PropTypes.arrayOf(PropTypes.shape({
    id: SFEntityID.isRequired,
    name: PropTypes.string.isRequired
  }))
};
